export enum Languages {
  EN = "EN",
  BG = "БГ",
  NO = "NO",
}
